import { Component, Inject } from '@angular/core';
import { NavbarComponent } from '@src/shared/navbar/navbar.component';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { IAuthService } from '@src/auth/auth.service.interface';
import { ConfigService } from '@src/services/layout/config.service';
import { LayoutService } from '@src/services/layout/layout.service';
import { BellRossPageType } from './../../bellross/services/bellross-page-type.service';

@Component({
  selector: 'app-bellross-navbar',
  templateUrl: './navbar-bellross.component.html',
  styleUrls: ['./navbar-bellross.component.scss'],
  providers: [ BellRossPageType ]
})

export class NavbarBellRossComponent extends NavbarComponent {
  currentLang = 'en';

  constructor(
    translate: TranslateService,
    @Inject('AuthService') authService : IAuthService,
    router: Router,
    configService: ConfigService,
    layoutService: LayoutService,
    public bellrossPageType: BellRossPageType) {
      super(translate, authService, router, configService, layoutService);
    }

  public IsInternalPage() {
    return this.bellrossPageType.isInternal();
  }
}
